import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/apiKeys/mutationTypes';

export default {
  [types.SET_API_KEYS]: createSetPropMutation('apiKeys'),
  [types.CLEAR_API_KEYS]: createClearPropMutation('apiKeys', []),
  [types.SET_CREATED_API_KEY]: createSetPropMutation('createdApiKey'),
  [types.CLEAR_CREATED_API_KEY]: createClearPropMutation('createdApiKey', {}),
};
